import * as PIXI from "pixi.js";
import { ControlConstants } from "../constant/ControlConstants";
import { AbstractPanelLayout } from "./AbstractPanelLayout";
/**
 * VerticalLayout.ts
 */
export class VerticalLayout extends AbstractPanelLayout {
    constructor(spacing, align = ControlConstants.LEFT, reverseOrder = false) {
        super();
        this.spacing = spacing;
        this.align = align;
        this.reverseOrder = reverseOrder;
    }
    equals(other) {
        return super.equals(other) &&
            (this.spacing === other.spacing) &&
            (this.align === other.align) &&
            (this.reverseOrder === other.reverseOrder);
    }
    apply(children) {
        let x = 0;
        let y = 0;
        let child;
        let panelSize = this.panel.getProperties().size;
        let childSize;
        let childrenReversed = children.slice().reverse();
        for (let i = 0; i < children.length; i++) {
            child = this.reverseOrder ? childrenReversed[i] : children[i];
            childSize = this.getChildSize(child);
            if (panelSize) {
                if (this.align == ControlConstants.RIGHT) {
                    x = panelSize.x;
                }
                else if (this.align == ControlConstants.CENTER) {
                    x = panelSize.x - childSize.x;
                }
            }
            this.addChild(child, new PIXI.Point(x, y));
            y += childSize.y + (typeof this.spacing === "function" ? this.spacing(i) : this.spacing);
        }
        if (childSize) {
            this.size = new PIXI.Point(childSize.x, y);
        }
    }
    clone() {
        return new VerticalLayout(this.spacing, this.align);
    }
    getSize() {
        return this.size;
    }
}
//# sourceMappingURL=VerticalLayout.js.map